import React from 'react';
import styled from 'styled-components';
import { useExternalHandlers } from '../../../services/actions/navigation/useExternalHandlers';
import { AuthCardInlineFooter, AuthLink } from '../authFormCommon';

const AuthSignUpAgreementText: React.FC = () => {
    const { openTermsAndConditions, openPrivacyPolicy } = useExternalHandlers();

    return (
        <AgreementText>
            <Line>By signing up, you agree to LeadDelta&apos;s</Line>
            <Line>
                <AuthLink onClick={() => openTermsAndConditions()}>Terms of Service</AuthLink>
                {' '}and{' '}
                <AuthLink onClick={() => openPrivacyPolicy()}>Privacy Policy.</AuthLink>
            </Line>
        </AgreementText>
    );
};

export default AuthSignUpAgreementText;

const AgreementText = styled(AuthCardInlineFooter)`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0;
`;

const Line = styled.span`
    display: block;
`;
